'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _FamilyGrid = require('./FamilyGrid.css');

var _FamilyGrid2 = _interopRequireDefault(_FamilyGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamilyGrid = (_dec = (0, _reactCssModules2.default)(_FamilyGrid2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FamilyGrid, _Component);

  function FamilyGrid() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FamilyGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FamilyGrid.__proto__ || (0, _getPrototypeOf2.default)(FamilyGrid)).call.apply(_ref, [this].concat(args))), _this), _this.renderCompanies = function () {
      return _config2.default.familyFunds.map(function (c, idx) {
        return _this.renderCompany(idx, c.fund_family_name, c.ff_all_asset_sum, c.ff_all_weight_total, c.num_equity_funds, 4);
      });
    }, _this.renderLogo = function (title) {
      var fileName = _format2.default.imgPath(title);
      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/fam/' + fileName + '.png');
        hasLogo = true;
      } catch (e) {
        console.log('');
      }
      if (hasLogo) {
        return _react2.default.createElement('img', {
          styleName: 'box-title-logo',
          src: companyLogo,
          alt: title
        });
      } else {
        // console.log(fileName)
        return _react2.default.createElement(
          'span',
          null,
          title
        );
      }
    }, _this.renderCompany = function (idx, title, asset, perc, numFunds, rating) {
      var safeName = encodeURIComponent(title);
      return _react2.default.createElement(
        'div',
        { key: idx, styleName: 'companies-box-wrap' },
        _react2.default.createElement(
          _components.Link,
          {
            to: _config2.default.links.fff + '/families?q=' + safeName,
            styleName: 'companies-link',
            title: title
          },
          _react2.default.createElement(
            'div',
            { styleName: 'companies-box-' + rating },
            _react2.default.createElement(
              'div',
              { styleName: 'box-title-wrapper' },
              _this.renderLogo(title)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'box-subtitle' },
              numFunds,
              ' funds analyzed'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'box-subtitle' },
              _format2.default.perc(perc, true),
              ' fossil fuel exposure'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'box-subtitle' },
              _format2.default.money(asset, true, 'US Dollar', false, 0),
              '\xA0 in fossil fuel stocks'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'learn-more-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'learn-more-' + rating },
                'More',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FamilyGrid, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'companies-boxes' },
        this.renderCompanies()
      );
    }
  }]);
  return FamilyGrid;
}(_react.Component)) || _class);
exports.default = FamilyGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FamilyGrid/FamilyGrid.js
// module id = 1386
// module chunks = 0